module.exports = __webpack_public_path__ + "img/account-06.6f629408.png";